import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { jobListings } from '../mock';
import { trackApplyNow, trackCountryFilter } from '../lib/analytics';

const COUNTRY_FILTERS = ['India', 'Poland', 'Romania', 'Croatia'];

const handleApplyClick = (job) => {
  trackApplyNow(job);
  toast.info("Online applications aren't open yet — drop us an email at office@zeevogo.com and our team will reach out to you.");
};

const JobsPage = () => {
  const [selectedCountry, setSelectedCountry] = useState('all');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const filteredJobs =
    selectedCountry === 'all' ? jobListings : jobListings.filter((job) => job.country === selectedCountry);

  return (
    <div className="min-h-screen" style={{ background: 'var(--zg-bg)' }}>
      <section className="px-6" style={{ padding: '128px 24px 80px', background: 'var(--zg-surface)' }}>
        <div className="mx-auto max-w-7xl">
          <div className="text-center mb-12">
            <div className="text-[13px] font-bold uppercase mb-3" style={{ letterSpacing: '.14em', color: '#b5720a' }}>
              Open roles
            </div>
            <h2 className="text-5xl font-bold mb-4" style={{ color: 'var(--zg-ink)' }}>
              Available Positions
            </h2>
            <p className="text-xl max-w-2xl mx-auto" style={{ color: 'var(--zg-muted)' }}>
              Browse through our current job openings across Europe
            </p>
          </div>

          <div className="flex justify-center mb-12">
            <div
              className="inline-flex flex-wrap justify-center rounded-full border p-1.5 gap-1"
              style={{ background: 'var(--zg-card)', borderColor: 'var(--zg-border)', boxShadow: '0 8px 24px rgba(45,42,36,.06)' }}
            >
              <button
                type="button"
                onClick={() => {
                  setSelectedCountry('all');
                  trackCountryFilter('all');
                }}
                className="rounded-full text-sm font-semibold px-[22px] py-2.5 transition-all"
                style={{
                  background: selectedCountry === 'all' ? '#2d2a24' : 'transparent',
                  color: selectedCountry === 'all' ? '#fff' : 'var(--zg-muted)',
                }}
              >
                All Countries
              </button>
              {COUNTRY_FILTERS.map((country) => (
                <button
                  key={country}
                  type="button"
                  onClick={() => {
                    setSelectedCountry(country);
                    trackCountryFilter(country);
                  }}
                  className="rounded-full text-sm font-semibold px-[22px] py-2.5 transition-all"
                  style={{
                    background: selectedCountry === country ? '#2d2a24' : 'transparent',
                    color: selectedCountry === country ? '#fff' : 'var(--zg-muted)',
                  }}
                >
                  {country}
                </button>
              ))}
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            {filteredJobs.map((job) => (
              <div
                key={job.id}
                className="rounded-[18px] border p-6 transition-all"
                style={{ borderColor: 'var(--zg-border)' }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = '#e08e0b';
                  e.currentTarget.style.transform = 'translateY(-4px)';
                  e.currentTarget.style.boxShadow = '0 18px 40px rgba(45,42,36,.1)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = 'var(--zg-border)';
                  e.currentTarget.style.transform = 'none';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                <div className="flex justify-between items-start mb-4">
                  <div>
                    <div className="text-2xl font-bold mb-1" style={{ color: 'var(--zg-ink)' }}>
                      {job.role}
                    </div>
                    <div style={{ color: 'var(--zg-muted)' }}>
                      {job.city}, {job.country}
                    </div>
                  </div>
                  <span className="text-xs whitespace-nowrap rounded-full px-3 py-1" style={{ background: '#dcfce7', color: '#166534' }}>
                    {job.status}
                  </span>
                </div>

                <div className="flex justify-between items-center rounded-[18px] px-4 py-4 mb-4" style={{ background: '#2d2a24', color: '#fff' }}>
                  <div>
                    <div className="text-[13px] opacity-80">Monthly Salary</div>
                    <div className="text-2xl font-bold">
                      {job.currency === 'EUR' ? '€' : '₹'}
                      {job.salaryRange ? job.salaryRange : job.salary}
                      {job.salaryRange && <span className="text-base ml-1">per month</span>}
                    </div>
                  </div>
                  <div className="text-right">
                    <div className="text-[13px] opacity-80">Open Positions</div>
                    <div className="text-2xl font-bold">{job.positions}</div>
                  </div>
                </div>

                <div className="mb-4">
                  <div className="font-semibold mb-2" style={{ color: 'var(--zg-ink)' }}>
                    Requirements
                  </div>
                  {job.requirements.map((req) => (
                    <div key={req} className="flex items-center gap-2 text-sm mb-1.5" style={{ color: 'var(--zg-muted)' }}>
                      ✓ {req}
                    </div>
                  ))}
                </div>

                <div className="mb-4">
                  <div className="font-semibold mb-2" style={{ color: 'var(--zg-ink)' }}>
                    Benefits
                  </div>
                  <div className="flex flex-wrap gap-2">
                    {job.benefits.map((benefit) => (
                      <span
                        key={benefit}
                        className="text-xs rounded-full px-3 py-1 border"
                        style={{ borderColor: 'var(--zg-border2)', color: 'var(--zg-ink2)' }}
                      >
                        {benefit}
                      </span>
                    ))}
                  </div>
                </div>

                <button
                  type="button"
                  onClick={() => handleApplyClick(job)}
                  className="w-full flex items-center justify-center h-11 rounded-full text-[15px] font-medium text-white transition-all"
                  style={{ background: '#2d2a24' }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-2px)';
                    e.currentTarget.style.background = '#3a362e';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'none';
                    e.currentTarget.style.background = '#2d2a24';
                  }}
                >
                  Apply Now
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default JobsPage;
